import React from 'react';
import classNames from 'classnames';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import tooltipStyles from 'shared/components/andtComponents/Tooltip.module.scss';
import styles from './valueTag.module.scss';

const ValueTag = ({ value, description, isSmallTag, tooltip }) => {

  const content = (
    <div className={classNames(styles.valueTagWrapper, isSmallTag && styles.smallTag, !value && styles.grayTag)}>
      <div className={styles.valueWrapper}>
        <span className={styles.value}>{value}</span>
        <span className={styles.description}>{description}</span>
      </div>
      <GenerateIcon className={styles.icon} iconName={ICONS.circleExclamationRegular.name} />
    </div>);
  return tooltip ? (
    <Tooltip placement="top"
             arrow classes={{ tooltip: tooltipStyles.whiteTooltip, arrow: tooltipStyles.whiteArrow }}
             title={<span className={tooltipStyles.tooltipText}>{tooltip}</span>}
    >
      {content}
    </Tooltip>
  ) : content;
};
export default ValueTag;
